<template>
  <div>
    <el-row style="padding-bottom:10px;" @keyup.enter.native="search">
      <el-col :span="24">
        编号：
        <el-input class="search-input" v-model="id" placeholder="请输入编号"></el-input>&nbsp;&nbsp;
        序列号：
        <el-input class="search-input" v-model="deviceSn" placeholder="请输入序列号"></el-input>&nbsp;&nbsp;连接类型：
        <DropdownSelect
          v-model="typeId"
          :action="api.admin.device.listtype"
          textField="name"
          valueField="id"
        ></DropdownSelect>&nbsp;&nbsp;经销商：
        <DropdownSelect
          v-model="dealerId"
          :action="api.admin.dealer.all"
          textField="name"
          valueField="id"
        ></DropdownSelect>
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
    </el-row>
    <page-table :data-api="this.api.admin.device" :viewable="false" keyField="id">
      <el-table-column prop="id" label="编号" width="80"></el-table-column>
      <el-table-column prop="deviceSn" label="序列号"></el-table-column>
      <el-table-column prop="typeName" label="设备类型"></el-table-column>
      <el-table-column prop="categoryName" label="设备名称"></el-table-column>
      <el-table-column prop="dealerName" label="经销商"></el-table-column>
      <el-table-column prop="expireData" label="过期时间" :formatter="dateFormatter"></el-table-column>
      <el-table-column label="绑定">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.dealerId==null"
            type="text"
            size="mini"
            @click="handleBind(scope.$index, scope.row)"
          >绑定经销商</el-button>
          <el-button
            v-if="scope.row.dealerId!=null"
            type="text"
            size="mini"
            @click="handleUnbind(scope.$index, scope.row)"
          >取消绑定</el-button>
        </template>
      </el-table-column>
      <el-table-column label="控制">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleStart(scope.$index, scope.row)">启动</el-button>
          <el-button type="text" size="mini" @click="handleStop(scope.$index, scope.row)">停止</el-button>
          <el-button type="text" size="mini" @click="handleUnlock(scope.$index, scope.row)">解锁</el-button>
          <el-button type="text" size="mini" @click="handleLock(scope.$index, scope.row)">锁定</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" :formatter="statusFormatter"></el-table-column>
      <el-table-column prop="unlocked" label="锁定状态" :formatter="unlockedFormatter"></el-table-column>
      <el-table-column prop="created" label="添加时间" :formatter="dateFormatter"></el-table-column>
    </page-table>
    <el-dialog title="绑定经销商" :visible.sync="dialogFormVisible">
      <el-form :model="bindForm" label-width="30%">
        <el-form-item label="设备id">{{bindForm.deviceId}}</el-form-item>
        <el-form-item label="序列号">{{bindForm.deviceSn}}</el-form-item>
        <el-form-item label="经销商">
          <DropdownSelect
            v-model="bindForm.dealerId"
            :action="api.admin.dealer.all"
            textField="name"
            valueField="id"
          ></DropdownSelect>
        </el-form-item>
        <el-form-item label="有效天数">
          <el-input v-model="bindForm.days" autocomplete="off" style="width: 100px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindDealer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      id: null,
      deviceSn: "",
      typeId: null,
      dealerId: null,
      dialogFormVisible: false,
      bindForm: {
        id: null,
        deviceSn: null,
        days: null,
        dealerId: null
      }
    };
  },
  created: function() {
    let that = this;
    let query = that.getQuery();
    that.id = query.id ? parseInt(query.id) : null;
    that.deviceSn = query.deviceSn;
    that.typeId = query.typeId ? parseInt(query.typeId) : null;
    that.dealerId = query.dealerId ? parseInt(query.dealerId) : null;
  },
  methods: {
    dateFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return cellValue;
      }
      return this.dateFormat("yyyy-mm-dd HH:MM:SS", new Date(cellValue));
    },
    statusFormatter(row, column, cellValue, index) {
      if (0 == cellValue) {
        return "离线";
      } else if (1 == cellValue) {
        return "在线";
      }
      return cellValue;
    },
    unlockedFormatter(row, column, cellValue, index) {
      if (0 == cellValue) {
        return "已锁定";
      } else if (1 == cellValue) {
        return "已解锁";
      } else if (2 == cellValue) {
        return "锁定中";
      } else if (3 == cellValue) {
        return "解锁中";
      }
      return cellValue;
    },
    search() {
      let params = this.getQuery();
      params.id = this.id;
      params.deviceSn = this.deviceSn;
      params.typeId = this.typeId;
      params.dealerId = this.dealerId;
      params.page = 1;
      let that = this;
      this.$router.replace({ query: params }, null, function() {
        that.$router.go(0);
      });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
    handleBind(index, row) {
      this.bindForm.deviceId = row.id;
      this.bindForm.deviceSn = row.deviceSn;
      this.bindForm.days = null;
      this.bindForm.dealerId = null;
      this.dialogFormVisible = true;
    },
    bindDealer() {
      let that = this;
      this.api.admin.device
        .bindDealer(Object.assign({}, this.bindForm))
        .then(function(response) {
          if (!response.data.errorCode) {
            that.dialogFormVisible = false;
            that.$message({
              type: "success",
              message: "绑定成功！",
              onClose: function() {}
            });
            that.$router.go(0);
          }
        });
    },
    handleUnbind(index, row) {
      this.$confirm("确定要解除设备与经销商绑定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var params = {};
        params.deviceId = row.id;
        params.dealerId = row.dealerId;
        this.api.admin.device.unbindDealer(params).then(response => {
          if (!response.data.errorCode) {
            this.$router.go(0);
          }
        });
      });
    },
    handleStart(index, row) {
      var params = {};
      params.deviceId = row.id;
      this.api.admin.device.start(params).then(response => {
        if (!response.data.errorCode) {
          this.$message({
            message: "指令发送成功！",
            type: "success"
          });
        }
      });
    },
    handleStop(index, row) {
      var params = {};
      params.deviceId = row.id;
      this.api.admin.device.stop(params).then(response => {
        if (!response.data.errorCode) {
          this.$message({
            message: "指令发送成功！",
            type: "success"
          });
        }
      });
    },
    handleUnlock(index, row) {
      this.$confirm("确定要解锁该设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let that = this;
        var params = {};
        params.deviceId = row.id;
        this.api.admin.device.unlock(params).then(response => {
          if (!response.data.errorCode) {
            this.$message({
              message: "指令发送成功！",
              type: "success",
              onClose: function() {
                that.$router.go(0);
              }
            });
          }
        });
      });
    },
    handleLock(index, row) {
      this.$confirm("确定要锁定该设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let that = this;
        var params = {};
        params.deviceId = row.id;
        this.api.admin.device.lock(params).then(response => {
          if (!response.data.errorCode) {
            this.$message({
              message: "指令发送成功！",
              type: "success",
              onClose: function() {
                that.$router.go(0);
              }
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.search-input {
  width: 150px;
}
</style>


// WEBPACK FOOTER //
// List.vue?419be20e